import { get } from 'lodash';
import COLORS from 'constants/colors';
import { fertilityProductSubstanceSets } from 'constants/products';
import {
  applicationProperties,
  applicationTypes,
  fertilityScriptTypes
} from 'constants/scripts';
import {
  FERTILIZER_BIN_ROUNDING_VALUE,
  NITROGEN_FERTILIZER_BIN_ROUNDING_VALUE,
  NUM_FERTILIZER_RATE_BINS
} from 'constants/data-viz';
import { getProductRateColorFromBins } from 'util/formatters/data-viz/product';
import { getAxisBins, getAxisBounds } from 'util/formatters/data-viz/axis';
import { getApplicationProperty } from 'util/applications';
import { convertForLocaleScalar } from 'util/unitConversion';
import { getProductRateUnitTypeByFormat } from 'util/unit';
import { getApplicationsByType } from '../../../scripts/zones/selectors';
import {
  getApplicationTypeForScriptType,
  getScriptTypeForScript
} from '../../../scripts/selectors';
import { getFormatFromZones } from 'products/selectors';

export const getFertilizerRateBinsForScript = (
  script,
  productValidationValues
) => {
  const { zones, tag } = script;
  const applicationType = getApplicationTypeForScriptType(
    getScriptTypeForScript(script)
  );
  const fertilizerApplications = getApplicationsByType({
    zones,
    applicationType
  });
  const format = getFormatFromZones(zones) || '';
  const substanceSet
    = tag === fertilityScriptTypes.NITROGEN
      ? fertilityProductSubstanceSets.NITROGEN
      : fertilityProductSubstanceSets.LPK;

  // TODO Probably going to want specific rates for application scripts - just use fertility rates for now
  const defaultRange
    = applicationType === applicationTypes.APPLICATION
      ? get(
        productValidationValues,
        `APPLICATION.${substanceSet.toUpperCase()}.${format.toUpperCase()}.RATE`
      )
      : get(
        productValidationValues,
        `FERTILITY.${substanceSet.toUpperCase()}.${format.toUpperCase()}.RATE`
      );

  const originalFert = fertilizerApplications[0];
  const originalMatterState
    = originalFert
    && originalFert[0]
    && originalFert[0].product
    && originalFert[0].product.matterState;
  const fertilizerRates = fertilizerApplications.map((app) => {
    let application = !app.length ? [{ rate: { q: null, u: 'gal/ac' } }] : app;
    if (
      app
      && app.length
      && app[0].product
      && app[0].product.matterState !== originalMatterState
    ) {
      application = originalFert;
    }
    const rate = getApplicationProperty(
      application,
      applicationProperties.RATE
    );
    // we converted the user's input so we need to convert it back
    return convertForLocaleScalar({
      quantity: rate.q,
      unit: rate.u,
      unitType: getProductRateUnitTypeByFormat(format)
    });
  });
  const bounds = getAxisBounds({ range: fertilizerRates, defaultRange });
  return getAxisBins({
    axisBounds: bounds,
    binRoundingValue:
      substanceSet === fertilityProductSubstanceSets.NITROGEN
        ? NITROGEN_FERTILIZER_BIN_ROUNDING_VALUE
        : FERTILIZER_BIN_ROUNDING_VALUE,
    numBins: NUM_FERTILIZER_RATE_BINS
  });
};

// TODO: Refactor this function out - it only exists as a wrapper for getFertilizerRateBinsForScript
export const getFertilizerRateLegendForScript = ({
  script,
  productValidationValues
}) => {
  if (!script) {
    return {};
  }

  return {
    bins: getFertilizerRateBinsForScript(script, productValidationValues)
  };
};

export const getFertilizerRateColorFromBins = ({ bins, rate }) => {
  return getProductRateColorFromBins({
    bins,
    colors: COLORS.rate[applicationTypes.FERTILIZER],
    rate
  });
};
